import { MenuItem } from '@common/services/navigation.service';
import {
    AdministrationPermissions,
    CodeListPermissions,
    VesselNotificationPermissions,
    VesselVisitPermissions,
    NoticeBoardPermissions,
    VesselPermitPermissions,
    ConveyancePermissions,
    EmsaPermissions,
    VesselShiftPermissions,
    VTSPermissions,
    FaqPermissions,
    DocumentPermissions,
    VesselPermissions,
    ParisMOUPermissions,
    VesselSchedulePermissions,
    VesselShortNotificationPermissions,
    MonstatReportingPermissions
} from '@common/classes/permissions';
import { User } from '@common/models/User';

export const NAVIGATION: MenuItem[] = [
    {
        title: 'Dashboard',
        icon: 'tachometer-alt',
        children: [
            {
                title: 'Task Manager',
                icon: 'chart-pie',
                route: '/task-manager'
            },
            {
                title: 'General Overview',
                icon: 'chart-pie',
                route: '/home',
                permissions: VesselNotificationPermissions.View.all
            },
            {
                title: 'Info',
                icon: 'chart-pie',
                route: '/home',
                permissions: VesselNotificationPermissions.View.all
            }
        ]
    },
    {
        title: 'Notice board',
        class: (user: User) => user.hasAnyNotifications ? 'text-danger' : null,
        icon: (user: User) => user.hasAnyNotifications ? 'exclamation-circle' : 'file-alt',
        permissions: [
            NoticeBoardPermissions
        ],
        children: [
            {
                title: 'Create new notice',
                icon: 'file-alt',
                route: '/notification/create',
                permissions: NoticeBoardPermissions.Action.create
            },
            {
                title: 'Notice list',
                icon: 'file-alt',
                route: '/notification/list',
                permissions: NoticeBoardPermissions.View.list
            },
            {
                title: 'Notice view',
                icon: 'file-alt',
                route: '/notification/userlist'
            }
        ]
    },
    {
        title: 'Chat',
        icon: 'comments',
        getNumber: (user: User) => user?.data?.totalUnseenChats,
        route: '/chat-note/list'
    },
    {
        title: 'Vessel Registry',
        icon: 'ship',
        permissions: [
            VesselPermissions, ParisMOUPermissions
        ],
        children: [
            {
                title: 'List',
                icon: 'file-alt',
                route: '/vessels',
                permissions: VesselPermissions.View.all
            },
            {
                title: 'Paris MOU',
                icon: 'list',
                route: '/paris-mou',
                permissions: ParisMOUPermissions.View.list
            },
            {
                title: 'Detained Vessel List',
                icon: 'ship',
                route: '/detained-vessels',
                permissions: VesselPermissions.View.detainedVesselList
            },
        ]
    },
    {
        title: 'Vessel Notifications',
        icon: 'ship',
        getNumber: (user: User) => user?.data?.totalWaitingVesselNotifications + user?.data?.totalWaitingVesselShifts,
        permissions: [
            VesselNotificationPermissions, VesselShiftPermissions
        ],
        children: [
            {
                title: 'Create new notification',
                icon: 'file-alt',
                route: '/vessel-notification/create',
                permissions: VesselNotificationPermissions.Action.create
            },
            {
                title: 'Vessel notification list',
                icon: 'file-alt',
                route: '/vessel-notification/list',
                getNumber: (user: User) => user?.data?.totalWaitingVesselNotifications,
                permissions: [
                    VesselNotificationPermissions.View
                ]
            },
            {
                title: 'Vessel shiftings list',
                icon: 'file-alt',
                route: '/vessel-shift/list',
                getNumber: (user: User) => user?.data?.totalWaitingVesselShifts,
                permissions: [
                    VesselShiftPermissions.View
                ]
            }
        ]
    },
    {
        title: 'Short Notifications',
        icon: 'ship',
        getNumber: (user: User) => user?.data?.totalWaitingVesselShortNotifications,
        permissions: [VesselShortNotificationPermissions],
        children: [
            {
                title: 'Create new short notification',
                icon: 'file-alt',
                route: '/short-vessel-notification/create',
                permissions: VesselShortNotificationPermissions.Action.create
            },
            {
                title: 'Short notification list',
                icon: 'file-alt',
                route: '/short-vessel-notification/list',
                permissions: [VesselShortNotificationPermissions.View]
            }
        ]
    },
    {
        title: 'Vessel Visits',
        icon: 'ship',
        route: '/vessel-visit/list',
        permissions: [
            VesselVisitPermissions, VesselVisitPermissions.View
        ]
    },
    /*     {
            title: 'Vessel Rotation',
            icon: 'ship',
            children: [
                {
                    title: 'List',
                    icon: 'file-alt',
                    route: '/home'
                }
            ]
        }, */
    {
        title: 'Vessel Schedule',
        icon: 'calendar',
        route: '/vessel-schedule/vessel-arrivals-departures',
        permissions: [
            VesselSchedulePermissions
        ]
    },
    /* {
        title: 'Tug boats and Pilotage',
        icon: 'ship',
        children: [
            {
                title: 'List',
                icon: 'file-alt',
                route: '/home'
            }
        ]
    }, */
    /* {
        title: 'Vessel Movements',
        icon: 'expand-arrows-alt',
        children: [
            {
                title: 'List',
                icon: 'file-alt',
                route: '/home'
            }
        ]
    },
    {
        title: 'Vessel Cargo',
        icon: 'file-alt',
        children: [
            {
                title: 'New Manifest',
                icon: 'file-alt',
                route: '/home'
            },
            {
                title: 'View Manifests',
                icon: 'file-alt',
                route: '/home'
            }
        ]
    },
    {
        title: 'Vessel Shifiting',
        icon: 'random',
        children: [
            {
                title: 'New ',
                icon: 'file-alt',
                route: '/home'
            },
            {
                title: 'Shifting list',
                icon: 'file-alt',
                route: '/home'
            }
        ]
    }, */
    /*{
        title: 'Vessel Permits',
        icon: 'ship',
        getNumber: (user: User) => user?.data?.totalWaitingPermits,
        permissions: [
            VesselPermitPermissions
        ],
        children: [
            {
                title: 'Create new vessel permit',
                icon: 'ship',
                route: '/vessel-permit/create',
                permissions: VesselPermitPermissions.Action.create
            },
            {
                title: 'Vessel permits list',
                icon: 'ship',
                route: '/vessel-permit/list',
                permissions: [
                    VesselPermitPermissions.View
                ]
            }
        ]
    },
    {
        title: 'Conveyance',
        icon: 'file-alt',
        getNumber: (user: User) => user?.data?.totalWaitingConveyances,
        permissions: [
            ConveyancePermissions
        ],
        children: [
            {
                title: 'Create new conveyance',
                icon: 'file-alt',
                route: '/conveyance/create',
                permissions: ConveyancePermissions.Action.create
            },
            {
                title: 'Conveyance list',
                icon: 'file-alt',
                route: '/conveyance/list',
                permissions: [
                    ConveyancePermissions.View.own,
                    ConveyancePermissions.View.all
                ]
            }
        ]
    },*/
    {
        title: 'EMSA',
        icon: 'envelope',
        route: '/emsa/ssn-messages',
        permissions: [
            EmsaPermissions, EmsaPermissions.View.list
        ]
    },
    {
        title: 'MONSTAT Reports',
        icon: 'file-lines',
        route: '/monstat-reporting',
        permissions: [MonstatReportingPermissions.View]
    },
    /*{
        title: 'Vessel Traffic System',
        icon: 'tower-cell',
        permissions: [
            VTSPermissions
        ],
        children: [
            {
                title: 'Dashboard',
                icon: 'table-columns',
                route: '/vts/dashboard',
                permissions: VTSPermissions.View.all
            },
            {
                title: 'VTS Logging',
                icon: 'tower-cell',
                route: '/vts/port-book',
                permissions: VTSPermissions.View.all
            },
            {
                title: 'VTS Personnel',
                icon: 'users',
                route: '/vts/vts-personnel',
                permissions: VTSPermissions.View.all
            },
            {
                title: 'VTS Administration',
                icon: 'cog',
                route: '/vts/vts-administration',
                permissions: VTSPermissions.View.all
            },
            {
                title: 'VTS History',
                icon: 'box-archive',
                route: '/vts/vts-history',
                permissions: VTSPermissions.View.all
            }
        ]
    },*/
    {
        title: 'Administration',
        icon: 'cog',
        permissions: [
            AdministrationPermissions, FaqPermissions, DocumentPermissions
        ],
        children: [
            {
                title: 'Users',
                icon: 'users',
                route: '/administration/user',
                permissions: [
                    AdministrationPermissions.User.viewAll,
                    AdministrationPermissions.User.viewOwn,
                ]
            },
            {
                title: 'Organizations',
                icon: 'building',
                route: '/administration/organization',
                permissions: [
                    AdministrationPermissions.Organization.viewAll,
                    AdministrationPermissions.Organization.viewOwn,
                ]
            },
            {
                title: 'Roles',
                icon: 'user-plus',
                route: '/administration/role',
                permissions: [
                    AdministrationPermissions.Role.viewAll,
                    AdministrationPermissions.Role.viewOwn
                ]
            },
            {
                title: 'FAQ Edit',
                icon: 'question',
                route: '/help/faq-edit',
                permissions: [FaqPermissions.Action]
            },
            {
                title: 'Documents Edit',
                icon: 'file-alt',
                route: '/help/document-edit',
                permissions: [DocumentPermissions.Action]
            },
        ]
    },
    {
        title: 'Code Lists',
        icon: 'file-alt',
        permissions: [
            CodeListPermissions
        ],
        children: [
            // {
            //     title: 'Country',
            //     icon: 'file-alt',
            //     route: '/code-list/country',
            //     permissions: [
            //         CodeListPermissions.Country.view
            //     ]
            // },
            // {
            //     title: 'Location',
            //     icon: 'file-alt',
            //     route: '/code-list/location',
            //     permissions: [
            //         CodeListPermissions.Location.view
            //     ]
            // },
            // {
            //     title: 'Terminal Operator',
            //     icon: 'file-alt',
            //     route: '/code-list/terminal',
            //     permissions: [
            //         CodeListPermissions.TerminalOperator.view
            //     ]
            // },
            // {
            //     title: 'Vessel Source',
            //     icon: 'file-alt',
            //     route: '/code-list/vessel-source',
            //     permissions: [
            //         CodeListPermissions.VesselSource.view
            //     ]
            // },
            // {
            //     title: 'Vessel Type',
            //     icon: 'file-alt',
            //     route: '/code-list/vessel-type',
            //     permissions: [
            //         CodeListPermissions.VesselType.view
            //     ]
            // },
            // {
            //     title: 'Vessel Permit Type',
            //     icon: 'file-alt',
            //     route: '/code-list/vessel-permit-type',
            //     permissions: [
            //         CodeListPermissions.VesselPermitType.view
            //     ]
            // },
            // {
            //     title: 'Vessel Contact Medium',
            //     icon: 'file-alt',
            //     route: '/code-list/vessel-contact-medium',
            //     permissions: [
            //         CodeListPermissions.VesselContactMedium.view
            //     ]
            // },
            // {
            //     title: 'Certificate Type',
            //     icon: 'file-alt',
            //     route: '/code-list/certificate-type',
            //     permissions: [
            //         CodeListPermissions.CertificateType.view
            //     ]
            // },
            // {
            //     title: 'VTS Event Description',
            //     icon: 'file-alt',
            //     route: '/code-list/event-description'
            // },
            {
                title: 'Email Subscription',
                icon: 'envelope',
                route: '/code-list/email-subscription'
            }
        ]
    },
    {
        title: 'Audit Logs',
        icon: 'list-alt',
        permissions: [AdministrationPermissions.AuditLogs.view],
        route: '/audit-logs',
    },
    {
        title: 'Help',
        icon: 'question-circle',
        children: [
            {
                title: 'FAQ',
                icon: 'question',
                route: '/help/faq-list',
                permissions: [FaqPermissions.View]
            },
            {
                title: 'Documents',
                icon: 'file-alt',
                route: '/help/document-list',
                permissions: [DocumentPermissions.View.all, DocumentPermissions.View.own]
            },
            {
                title: 'Manuals',
                icon: 'video',
                route: '/help/manuals-view'
            }
        ]
    }

];
